<template>
  <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
    <vs-sidebar
      class="items-no-padding"
      parent="#chat-app"
      :hidden-background="clickNotClose"
      v-model="isChatSidebarActive"
      id="chat-list-sidebar"
    >
      <div class="chat__profile-search flex p-4">
        <vs-input
          icon="icon-search"
          icon-pack="feather"
          class="w-full input-rounded-full no-icon-border"
          placeholder="Pesquisar"
          v-model="searchQuery"
        />
      </div>
      <!-- 
      <div class="chat__profile-search flex px-4 mb-4">
        <MobileSalvarDados :dispositivo="dispositivo" :relationship="messenger" />
      </div>
      -->
      <vs-divider class="d-theme-border-grey-light m-0" />
      <VuePerfectScrollbar class="chat-scroll-area" :settings="settings">
        <div class="chat__chats-list mb-8">
          <ul class="chat__active-chats bordered-items">
            <li v-show="loading">
              <div id="loading" class="vs-con-loading__container"></div>
            </li>
            <li v-show="contacts.length === 0 && !loading" class="p-6">Nenhum contato capturado ainda.</li>
            <li v-show="contacts.length > 0 && !loading && meta.pagination.total_pages > 1" class="p-6 text-center">
              <vs-button color="primary" type="filled" @click="page(-1)" :disabled="loadingPage || meta.pagination.current_page === 1"><i class="fas fa-caret-circle-left"></i></vs-button>
              Página {{ meta.pagination.current_page }} de {{ meta.pagination.total_pages }}
              <vs-button color="primary" type="filled" @click="page(1)" :disabled="loadingPage || meta.pagination.current_page === meta.pagination.total_pages"><i class="fas fa-caret-circle-right"></i></vs-button>
            </li>
            <li
              class="cursor-pointer"
              v-for="(contact, index) in contactsList"
              :key="index"
              @click="updateActiveChatUser(contact.contactId)"
            >
              <chat-contact
                :contact="contact"
                :lastMessaged="contact.date || contact.datetime"
                :unseenMsg="contact.count"
                :isActiveChatUser="isActiveChatUser(contact.contactId)"
              ></chat-contact>
            </li>
            <li v-show="contacts.length > 0 && !loading && meta.pagination.total_pages > 1" class="p-6 text-center">
              <vs-button color="primary" type="filled" @click="page(-1)" :disabled="loadingPage || meta.pagination.current_page === 1"><i class="fas fa-caret-circle-left"></i></vs-button>
              Página {{ meta.pagination.current_page }} de {{ meta.pagination.total_pages }}
              <vs-button color="primary" type="filled" @click="page(1)" :disabled="loadingPage || meta.pagination.current_page === meta.pagination.total_pages"><i class="fas fa-caret-circle-right"></i></vs-button>
            </li>
          </ul>
        </div>
      </VuePerfectScrollbar>
    </vs-sidebar>

    <!-- RIGHT COLUMN -->
    <div
      class="chat__bg app-fixed-height chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
      :class="{ 'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null }"
    >
      <template v-if="activeChatUser">
        <div class="chat__navbar">
          <chat-navbar
            :isSidebarCollapsed="!clickNotClose"
            :contactId="activeChatUser"
            :isPinnedProp="isChatPinned"
            :contacts="contacts"
            @openContactsSidebar="toggleChatSidebar(true)"
            @toggleIsChatPinned="toggleIsChatPinned"
          ></chat-navbar>
        </div>
        <VuePerfectScrollbar
          class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
          :settings="settings"
          ref="chatLogPS"
        >
          <div class="chat__log" ref="chatLog">
            <chat-log
              :messenger="messenger"
              :contactId="activeChatUser"
              v-if="activeChatUser"
              :contacts="contacts"
            ></chat-log>
          </div>
        </VuePerfectScrollbar>
      </template>
      <template v-else>
        <div class="flex flex-col items-center">
          <a href="javascript:;" @click.stop="toggleChatSidebar(true)">
            <feather-icon
              icon="MessageSquareIcon"
              class="mb-4 bg-white p-8 shadow-md rounded-full"
              svgClasses="w-16 h-16"
            ></feather-icon>
          </a>
          <h4
            class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer hidden md:block"
            @click.stop="toggleChatSidebar(true)"
          >
            Escolha um Contato
          </h4>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ChatContact from './ChatContact.vue'
import ChatNavbar from './ChatNavbar.vue'
import ChatLog from './ChatLog.vue'

export default {
  name: 'vx-sidebar',
  props: {
    messenger: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      active: true,
      isHidden: false,
      searchContact: '',
      activeChatUser: null,
      typedMessage: '',
      isChatPinned: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      clickNotClose: true,
      isChatSidebarActive: true,
      windowWidth: window.innerWidth,
      contacts: [],
      loading: true,
      loadingPage: true,
      searchQuery: '',
      dispositivo: {
        uid: ''
      },
      meta: {
        pagination: {
          count: 1,
          current_page: 1,
          total_pages: 1
        }
      }
    }
  },
  mounted: function () {
    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    })

    this.dispositivo = JSON.parse(this.$localStorage.get('mobile'))
    this.load()
  },
  computed: {
    contactsList() {
      if (this.searchQuery) {
        return this.contacts.filter((item) => {
          return this.searchQuery
          .toLowerCase()
          .split(' ')
          .every((v) => item.name.toLowerCase().includes(v))
        })
      } else {
        return this.contacts
      }
    },
    isActiveChatUser() {
      return (contactId) => contactId == this.activeChatUser
    }
  },
  methods: {
    updateActiveChatUser(contactId) {
      this.activeChatUser = contactId
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    sendMsg() {
      if (!this.typedMessage) return
      const payload = {
        isPinned: this.isChatPinned,
        msg: {
          textContent: this.typedMessage,
          time: String(new Date()),
          isSent: true,
          isSeen: false
        },
        id: this.activeChatUser
      }
      this.$store.dispatch('chat/sendChatMessage', payload)
      this.typedMessage = ''
      this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    toggleIsChatPinned(value) {
      this.isChatPinned = value
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth
      this.setSidebarWidth()
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    },
    load() {
      this.$api.get(`/api/v${this.dispositivo.panel_version}/mobile/${this.messenger}/${this.dispositivo.uid}/contact?page=` + this.meta.pagination.current_page).then((response) => {
        this.loading = false
        this.contacts = response.data.data
        this.meta = response.data.meta || {
          pagination: {
            count: 1,
            current_page: 1,
            total_pages: 1
          }
        }
        this.loadingPage = false
        this.toggleChatSidebar(true)
      })
    },
    page(number) {
      this.meta.pagination.current_page += number
      this.loadingPage = true
      this.load()
    }
  },
  components: {
    VuePerfectScrollbar,
    ChatContact,
    ChatNavbar,
    ChatLog
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize)
    })
    this.setSidebarWidth()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuesax/apps/chat.scss';

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
